import { UsersApi } from '@/api';
import { UserStatus } from '@/models';
import { Module } from 'vuex';
import { Actions } from './actions';
import { Mutations } from './mutations';
import { RootState } from './root.store';

const usersApi = new UsersApi();

export interface UsersState {
  currentUserStatus: UserStatus;
}

export const UsersModule: Module<UsersState, RootState> = {
  state: {
    currentUserStatus: null as unknown as UserStatus,
  },
  mutations: {
    [Mutations.users.setCurrentUserStatus](state, status: UserStatus) {
      state.currentUserStatus = status;
    },
  },
  actions: {
    async [Actions.users.fetchCurrentUserStatus]({ commit }): Promise<UserStatus> {
      const status = await usersApi.fetchCurrentUserStatus();
      commit(Mutations.users.setCurrentUserStatus, status);

      return status;
    },
    async [Actions.users.fetchAppInsightsInstrumentationKey](): Promise<string> {
      const appInsightsInstrumentationKey = await usersApi.fetchAppInsightsInstrumentationKey();

      return appInsightsInstrumentationKey;
    },
  },
};
